module.exports = __webpack_public_path__ + "static/media/parser.c657c41e.mjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/language/parser.mjs
// module id = 1299
// module chunks = 0